import { createFileRoute } from '@tanstack/react-router';
import { AgencyCampaignsPage } from '../features/agency/AgencyCampaignsPage/AgencyCampaignsPage';
import { agencyCampaignSectionSchema } from '../features/agency/model';
import { agencyCampaignRouteSearchSchema } from '../features/agency/agencyCampaignRouteSearch';
export const Route = createFileRoute('/a/$agencyId_/campaigns/$section')({
  params: {
    parse: (params) => ({ ...params, section: agencyCampaignSectionSchema.parse(params.section) }),
    stringify: (params) => params,
  },
  validateSearch: agencyCampaignRouteSearchSchema,
  component: AgencyCampaignsRoute,
});
function AgencyCampaignsRoute() {
  const { agencyId, section } = Route.useParams();
  return <AgencyCampaignsPage key={`${agencyId}-${section}`} section={section} />;
}
